import React, { useState } from 'react';
import { apiFetch } from '../../../utils/api';
import { STEPS } from '../CheckoutModal';

const VisitorInfoStep = ({ state, dispatch, storeData, storeSlug, goToStep, goBack, cartItems, cartTotal }) => {
  const [email, setEmail] = useState(state.email || '');
  const [phone, setPhone] = useState(state.whatsappNumber || '');
  const [name, setName] = useState(state.fullName || '');
  const [emailError, setEmailError] = useState('');

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  const handleContinue = (e) => {
    e.preventDefault();
    setEmailError('');

    if (!email.trim()) {
      setEmailError('Email address is required.');
      return;
    }

    if (!validateEmail(email.trim())) {
      setEmailError('Please enter a valid email address.');
      return;
    }

    // Dispatch field updates to parent reducer
    dispatch({
      type: 'SET_FIELDS',
      fields: {
        email: email.trim(),
        whatsappNumber: phone.trim(),
        fullName: name.trim()
      }
    });

    // Track abandoned checkout in background (don't block navigation)
    apiFetch('/abandoned-carts/track-checkout', {
      method: 'POST',
      body: JSON.stringify({
        sessionId: localStorage.getItem('cartId') || 'anonymous',
        storeSlug,
        items: cartItems.map(item => ({
          productId: item.product.id || item.product._id,
          name: item.product.name,
          quantity: item.qty,
          price: item.product.price,
          variations: item.variations || null
        })),
        subtotal: cartTotal,
        contact: {
          email: email.trim(),
          phone: phone.trim(),
          name: name.trim()
        }
      })
    }).catch(() => {});

    goToStep(STEPS.PURCHASE_INFO);
  };

  return (
    <div className="cm-step cm-visitor-info-step">
      <div className="cm-info-banner">
        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        <span>Enter your details to continue. We'll save your progress so you can return later.</span>
      </div>

      <form className="cm-form" onSubmit={handleContinue}>
        <div className="cm-form-group">
          <label className="cm-label" htmlFor="cm-visitor-email">
            Email Address <span className="cm-required">*</span>
          </label>
          <input
            id="cm-visitor-email"
            className={`cm-input${emailError ? ' cm-input-error' : ''}`}
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (emailError) setEmailError('');
            }}
            required
            autoFocus
          />
          {emailError && <p className="cm-form-error">{emailError}</p>}
        </div>

        <div className="cm-form-group">
          <label className="cm-label" htmlFor="cm-visitor-phone">
            Phone Number <span className="cm-optional">(optional)</span>
          </label>
          <input
            id="cm-visitor-phone"
            className="cm-input"
            type="tel"
            placeholder="+234 800 000 0000"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        <div className="cm-form-group">
          <label className="cm-label" htmlFor="cm-visitor-name">
            Full Name <span className="cm-optional">(optional)</span>
          </label>
          <input
            id="cm-visitor-name"
            className="cm-input"
            type="text"
            placeholder="John Doe"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="cm-step-footer">
          <button type="button" className="cm-btn cm-btn-secondary" onClick={goBack}>
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Back
          </button>
          <button type="submit" className="cm-btn cm-btn-primary">
            Continue
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

export default VisitorInfoStep;
